module.exports = __webpack_public_path__ + "static/media/flag_en.44b4cac0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/flashcard/flag_en.svg
// module id = 129
// module chunks = 0